const ApiAttributesKeys = {
  chapterIdKey: 'id',
  chapterNameKey: 'chapter_name',
  videoTableNameKey: 'cfa1_2025_videos',
  videoTableChapterIdKey: 'chapter_id',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Videos/ApiAttributesKays.js